var _path, _path2, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTickList(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 35,
    viewBox: "0 0 36 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.5351 35C21.4275 34.9978 25.2079 33.6988 28.2801 31.3079C31.3516 28.9173 33.539 25.571 34.4962 21.7981C35.4537 18.0254 35.1269 14.0413 33.5672 10.4749C33.3087 9.88547 32.7556 9.47841 32.116 9.40709C31.476 9.33615 30.8471 9.61138 30.4653 10.1299C30.0838 10.6484 30.0081 11.3312 30.2662 11.9206C32.0391 15.9656 31.7835 20.6123 29.5776 24.4381C27.3712 28.2639 23.4774 30.8127 19.0893 31.3042C14.7004 31.7956 10.3392 30.1713 7.34109 26.9282C4.34323 23.6852 3.06619 19.21 3.9004 14.8728C4.73503 10.5363 7.58138 6.85459 11.5688 4.9551C15.5559 3.0559 20.2081 3.16592 24.1015 5.25077C24.5227 5.53641 25.045 5.63075 25.5393 5.51004C26.0341 5.38933 26.4542 5.06542 26.6968 4.61784C26.9389 4.17026 26.9805 3.641 26.8115 3.16108C26.6422 2.68118 26.2778 2.29489 25.8082 2.09838C22.6711 0.406083 19.0915 -0.288158 15.5491 0.108932C12.0068 0.506022 8.67005 1.97581 5.98608 4.32107C3.30173 6.66634 1.39729 9.77526 0.528182 13.2323C-0.340928 16.6893 -0.133721 20.3294 1.12211 23.6654C2.37833 27.0017 4.6229 29.8744 7.55619 31.8999C10.4899 33.9254 13.9717 35.0066 17.5357 34.9992L17.5351 35Z",
    fill: "url(#paint0_linear_1_17034)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.2086 12.1915C9.74284 11.7465 9.07536 11.5838 8.4569 11.7647C7.83882 11.9456 7.36414 12.4426 7.21181 13.0685C7.05951 13.6943 7.25267 14.3541 7.71845 14.7986L15.6443 22.3774H15.6439C15.9786 22.6976 16.4239 22.8767 16.8871 22.8774H16.9547H16.9543C17.4405 22.8588 17.8989 22.6445 18.2242 22.2831L33.4584 5.34211C33.8885 4.8637 34.0308 4.19172 33.8317 3.57964C33.6322 2.96788 33.1215 2.50837 32.4919 2.37506C31.8623 2.24171 31.2093 2.45454 30.7788 2.93296L16.7922 18.4866L10.2086 12.1915Z",
    fill: "url(#paint1_linear_1_17034)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1_17034",
    x1: -2.68782,
    y1: 35,
    x2: 38.2504,
    y2: 5.14705,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1E5CEF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1DD6FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1_17034",
    x1: 5.10767,
    y1: 22.8774,
    x2: 30.3077,
    y2: -1.03817,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1E5CEF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1DD6FF"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTickList);
export default __webpack_public_path__ + "static/media/tick_list.0a2157c1f8353207351172fb86270e40.svg";
export { ForwardRef as ReactComponent };